

// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-pro/css/all.css";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import 'lightgallery/src/sass/lightgallery.scss';
import 'bootstrap';
import 'slick-carousel';

import sidebarNav from './header/sidebar-nav';
import basicNavigation from './header/header-basic';
import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

import Instafeed from 'instafeed.js';

window.Instafeed = Instafeed;

sidebarNav();

$(window).on("load resize",function(){
    var tileWidth = $('.square-tile').outerWidth();
    $('.square-tile').css('height', tileWidth + 'px');

    $('.staff-img').css('height', $('.staff-img').outerWidth() + 'px');

    //homeVideoBackground();
});

function homeVideoBackground(){
    if ($('#carringtonCrispVideo').length > 0) {
        var videoHeight = $('#carringtonCrispVideo').height();
        $('.home-header-background').height(videoHeight + 50);
        $('section.home-video').height(videoHeight);
        $('.home-video-overlay').height(videoHeight);
    }
}
function sizing() {
    var maxHeight = 0;
    $(".row .cs-tile-wrapper").each(function(){
        $(".cs-tile").find('.cs-content').removeAttr('style');
    });
    $(".cs-tile-wrapper").each(function(){
        if ($(this).find('.cs-content').outerHeight() > maxHeight) {
            maxHeight = $(this).find('.cs-content').outerHeight();
        }
    });
    $(".cs-tile").find('.cs-content').css('height', maxHeight + 'px');

    homeVideoBackground();
}

$(document).ready(sizing);
$(window).resize(sizing);

/*$(document).ready(function(){
    if ($('#carringtonCrispVideo').length > 0) {
        homeVideoBackground();
        //showing video after page loads
        setTimeout(function(){
            $('.video-wrapper').removeClass('video-hidden');
        }, 2000);

        setTimeout(function(){
            $('#carringtonCrispVideo')[0].play();
            $('.home-video-overlay').removeClass('d-none');
            $('.home-video-content').removeClass('d-none');
        }, 1500);
    }
});*/

$(function () {
    basicNavigation();

    if ($('#carringtonCrispVideo').length > 0) {
        $('#carringtonCrispVideo')[0].play();
    }


    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');

    $('.project-slider').slick({
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: true,
        slidesToShow: 5,
        prevArrow: $('.prev-arrow'),
        nextArrow: $('.next-arrow'),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

    $('.home-testimonial').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        arrows: false,
        dots: true,
    });

    $('.collection-testimonial').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        loop: true,
        fade: true,
        arrows: false,
        dots: true,
    });

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });


    $('.elemental-sponsors .slick').slick({
        slidesToShow: 5,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: false,
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 2
                }
            }
        ]
    });

    $('.hail-carousel').each(function(index, element){
        //Build carousel options (from the Hail carousel DataObject)
        const slickOptions = {
            lazyLoad: 'ondemand',
            dots: ($(element).data('showdots') === "Yes"),
            slidesToShow: $(element).data('lg-toshow'),
            slidesToScroll: $(element).data('lg-toscroll'),
            responsive: [
                {
                    breakpoint: $(element).data('md-break'),
                    settings: {
                        slidesToShow: $(element).data('md-toshow'),
                        slidesToScroll: $(element).data('md-toscroll')
                    }
                },
                {
                    breakpoint: $(element).data('sm-break'),
                    settings: {
                        slidesToShow: $(element).data('sm-toshow'),
                        slidesToScroll: $(element).data('sm-toscroll'),
                        arrows: false
                    }
                }
            ]
        };

        $(element).slick(slickOptions);
    });

});
